import { Component} from "@angular/core";
import {
  HsLayerManagerService,
  HsEventBusService,
  HsLegendService,
  HsLanguageService,
} from "hslayers-ng";

@Component({
  selector: "overlay-legend",
  templateUrl: "./legend.component.html",
  styleUrls: ["./legend.component.scss"],
})
export class LegendComponent {
  legendExpanded = false;
  layers = [];
  constructor(
    public HsLegendService: HsLegendService,
    private HsLayerManagerService: HsLayerManagerService,
    private HsEventBusService: HsEventBusService,
    public HsLanguageService: HsLanguageService
  ) {
    this.HsEventBusService.layerManagerUpdates.subscribe(() => {
      this.layers = this.HsLayerManagerService.data.layers
        .map((layer) => {
          return this.HsLegendService.getLayerLegendDescriptor(layer.layer);
        })
        .filter((lyr) => lyr.title != "cfd");
    });
  }

}
